<template>
	<v-sheet elevation="0" max-width="700px" class="mx-auto">
		<FunctionTitle :title="''" />
		<CommonFlame :title="'社員情報編集'">
			<v-form ref="form" v-model="valid">
				<UserFormEmail :email.sync="user.email" />
				<UserFormPersonalColor :personalColor.sync="user_info.personalColor" />
				<v-row no-gutters class="my-4" justify="center">
					<v-btn color="secondary" :disabled="!valid" @click.prevent="updateUser">
						<v-icon class="mr-2">mdi-pencil</v-icon>
						更新する</v-btn>
				</v-row>
			</v-form>
		</CommonFlame>
	</v-sheet>
</template>

<script>
import axios from "axios"
import authenticate from "../../helper/authenticate"
import errorHandling from "../../helper/errorHandling"
import UserFormEmail from "./forms/UserFormEmail.vue"
import UserFormPersonalColor from "../../view/user/forms/UserFormPersonalColor.vue"
import FunctionTitle from "../shared/FunctionTitle.vue"
import CommonFlame from "../shared/CommonFlame.vue"

export default {
	components: {
		UserFormEmail,
		UserFormPersonalColor,
		FunctionTitle,
		CommonFlame,
	},
	data() {
		return {
			user: {
				id: this.$route.params["id"],
				email: "",
			},
			user_info: {
				personalColor: "",
			},
			valid: false,
			errors: [],
		}
	},
	mounted() {
		authenticate.authenticateUser()
		this.fetchUser()
	},
	methods: {
		fetchUser() {
			const headers = authenticate.setHeader()

			axios
				.get(`/erp/v1/users/${this.user.id}/edit`, {
					headers,
				})
				.then((res) => {
					this.user.id = res.data.user.id
					this.user.email = res.data.user.email
					this.user_info.personalColor = res.data.user_info.color
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		updateUser() {
			const headers = authenticate.setHeader()
			axios
				.put(
					`/erp/v1/users/${this.user.id}`,
					{
						user_main: {
							user: {
								id: this.user.id,
								email: this.user.email,
							},
							user_info: {
								color: this.user_info.personalColor,
							},
						},
					},
					{
						headers,
					}
				)
				.then((res) => {
					this.$store.commit("setFlash", {
						type: "notice",
						text: "社員情報を更新しました。",
					})
					this.$store.dispatch("auth/setUid", this.user.email)
					this.$router.push({ name: "erp_settings" })
				})
				.catch((err) => {
					if (err.response?.status == 400) {
						this.errors = err.response.data?.errors
					}
					errorHandling.errorResponse(err)
				})
		},
	},
}
</script>
